import {imageMap} from "../../../../images/imageMap.ts";
import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";
import {Link} from "react-router-dom";
import Icon from "../../../../components/selfcare/Icon.tsx";
import IconArrow from "../../../../components/icons/IconArrow.tsx";
import {ScrollToAnchorPoint} from "../../../../util/ScrollToAnchor.tsx";
import {WhatConnectionType} from "../../../../components/help/CommonQuestions.tsx";
import Routing from "../../../../Routing.ts";

export default function UnitsOnWifiArticle() {
    return (
        <>
            <article className={'help-article-content'}>
                <div className={'article'}>
                    <h2>
                        Vælg dit produkt for at finde hjælp
                    </h2>
                    <div className={'button-container'}>
                        <a href={'#fiber'} className={'button button--montserrat with-icon teal'}>
                            <span className="text">
                                Jeg har fibernet
                            </span>
                            <Icon component={IconArrow} className={'icon-arrow-down'}/>
                        </a>
                        <a href={'#mbb-dsl'} className={'button button--montserrat with-icon teal'}>
                            <span className="text">
                                Jeg har 5G-internet / internet via telefonstikket
                            </span>
                            <Icon component={IconArrow} className={'icon-arrow-down'}/>
                        </a>
                        <a href={'#coax'} className={'button button--montserrat with-icon teal'}>
                            <span className="text">
                                Jeg har internet via kabel-tv-stikket
                            </span>
                            <Icon component={IconArrow} className={'icon-arrow-down'}/>
                        </a>
                        <a href={'#not-sure'} className={'button button--montserrat with-icon teal'}>
                            <span className="text">
                                Jeg ved ikke, hvilket produkt jeg har
                            </span>
                            <Icon component={IconArrow} className={'icon-arrow-down'}/>
                        </a>
                    </div>
                </div>

                <ScrollToAnchorPoint id={'fiber'} className={'id-anchor--help'}/>
                <div className={'article'}>
                    <h2>
                        Jeg har fibernet
                    </h2>
                    <ol className={'list list--number list--image'}>
                        <li>
                            <p>
                                Åbn <strong>Internet</strong>-fanen i <Link to={Routing.Selfcare.Internet}>Mit Hiper</Link>.
                            </p>
                        </li>
                        <li>
                            <p>
                                Rul ned til <strong>Wifi-indstillinger og -oversigt</strong>.
                            </p>
                        </li>
                        <li>
                            <p>
                                Verificér dig ved at trykke <strong>Send sms-kode</strong> og indtast koden i feltet.
                            </p>
                        </li>
                        <img
                            className={'br1 box-shadow'}
                            src={imageMap.help.network.selfcareInternetVerify}
                            alt="Skærmbillede af verificeringsboks i Mit Hiper."
                        />
                        <li>
                            <p>
                                Rul ned til <strong>Signalstyrke på dine enheder</strong> &ndash; her kan du se enhederne på dit wifi.
                            </p>
                        </li>
                        <img
                            className={'br1 box-shadow'}
                            src={imageMap.help.network.selfcareInternetDeviceList}
                            alt="I Mit Hiper kan du se wifi-signalstyrken på dine enheder, hvis du har fibernet."
                        />
                    </ol>
                </div>

                <ScrollToAnchorPoint id={'mbb-dsl'} className={'id-anchor--help'}/>
                <div className="article">
                    <div className="paragraph">
                        <h2>
                            Jeg har 5G-internet / internet via telefonstikket
                        </h2>
                        <ol className="list list--number list--image">
                            <li>
                                <p>
                                    Indtast din routers IP-adresse i søgefeltet i din browser.
                                </p>
                                <ul className="list list--bullet">
                                    <li>
                                        <p>IP-adressen står bag på din router.</p>
                                    </li>
                                    <li>
                                        <p>Standard er <code className={'inline-code'}>192.168.1.1</code>.</p>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <p>
                                    Log ind med dit brugernavn og adgangskode, som står bag på din router:
                                </p>
                            </li>
                            <img
                                src={imageMap.help.network.gui.zyxel_ex3.gui_login}
                                alt="Bagside af zyxel router med login oplysninger."
                            />
                            <li>
                                <p>
                                    Hvis du logger på for første gang, kan du ændre dit password.
                                    Du kan også bare vælge <strong>Skip</strong>.
                                </p>
                            </li>
                            <img
                                src={imageMap.help.network.gui.zyxel.zyxelGuiPassReset}
                                alt="Zyxel router skift kodeord"
                            />
                            <li>
                                <p>
                                    Hvis du kommer til denne side, kan du også vælge <strong>Skip</strong>.
                                </p>
                            </li>
                            <img
                                src={imageMap.help.network.gui.zyxel.zyxelGuiQuickstartWizard}
                                alt="Hurtig start på zyxel router."
                            />
                            <li>
                                <p>
                                    Klik på den gule pil i boksen <strong>Connectivity</strong>.
                                </p>
                            </li>
                            <img
                                src={imageMap.help.network.gui.zyxel.zyxelGuiHomeConnectivity}
                                alt="Zyxel router admin."
                            />
                            <li>
                                <p>
                                    Nu får du vist en liste med dine IP-adresser, mac-adresser og enheder på dit wifi.
                                </p>
                            </li>
                            <img
                                src={imageMap.help.network.gui.zyxel.zyxelconnect1}
                                alt="Zyxel router admin."
                            />
                            <li>
                                <p>
                                    Bruger du mesh-enheder? Så skal du vælge <strong>List</strong> til højre for <strong>Topology</strong>.
                                </p>
                            </li>
                            <img
                                src={imageMap.help.network.gui.zyxel.zyxelconnect2}
                                alt="Zyxel router admin."
                            />
                            <li>
                                <p>
                                    Nu kan du se en liste over enhederne på dit wifi.
                                </p>
                            </li>
                            <img
                                src={imageMap.help.network.gui.zyxel.zyxelconnect3}
                                alt="Zyxel router admin."
                            />
                        </ol>
                        <p>
                            På fibernet behøver du ikke bekymre dig om at have for mange enheder på dit wifi.
                            Du kan nemlig være online med op til 32 enheder på din Zyxel-router.
                            Hvis du alligevel har for mange enheder tilkoblet, kan du ringe til os,
                            så hjælper vi dig med at fjerne nogle enheder.
                        </p>
                    </div>
                </div>

                <ScrollToAnchorPoint id={'coax'} className={'id-anchor--help'}/>
                <div className="article">
                    <div className="paragraph">
                        <h2>
                            Jeg har internet via kabel-tv-stikket
                        </h2>
                        <ol className="list list--number list--image">
                            <li>
                                <p>
                                    Indtast din routers IP-adresse i søgefeltet i din browser.
                                </p>
                                <ul className="list list--bullet">
                                    <li>
                                        IP-adressen står bag på din router.
                                    </li>
                                    <li>
                                        Standard er <code className={'inline-code'}>192.168.0.1</code>.
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <p>
                                    Log ind med dit brugernavn og adgangskode, som står bag på din router.
                                </p>
                                <ul className={'list list--bullet'}>
                                    <li>
                                        <p>
                                            Dit brugernavn står ud for <strong>Username</strong>, og din adgangskode står ud for <strong>Admin password</strong>.
                                        </p>
                                    </li>
                                </ul>
                            </li>
                            <img
                                src={imageMap.help.network.gui.sagemcom_3890.router_login}
                                alt="Bagside af Sagem router med login-oplysninger."
                            />
                            <li>
                                <p>
                                    Du kan se dine forbundne enheder på forsiden:
                                </p>
                                <ul className="list list--bullet">
                                    <li>
                                        Under <strong>Ethernet</strong> kan du enheder forbundet til din router med et netværkskabel.
                                    </li>
                                    <li>
                                        Under <strong>Wi-Fi 2,4&nbsp;GHz</strong> og <strong>Wi-Fi 5&nbsp;GHz</strong> kan du se enheder på hhv. dit 2,4 og 5&nbsp;GHz-netværk.
                                    </li>
                                </ul>
                            </li>
                            <img
                                src={imageMap.help.network.gui.sagemcom_3890.sagemAdmin}
                                alt="Sagem login admin."
                            />
                        </ol>
                        <p>
                            Så enkelt og simpelt er det at tjekke hvilke enheder, som er forbundet til dit wifi.
                        </p>
                    </div>
                </div>

                <ScrollToAnchorPoint id={'not-sure'} className={'id-anchor--help'}/>
                <div className={'article'}>
                    <div className={'paragraph'}>
                        <h3>{WhatConnectionType.question}</h3>
                        {WhatConnectionType.answer}
                    </div>
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        "category": "internet-og-wifi",
                        "article": "forventninger-til-wifi",
                        "name": "Hvad kan jeg forvente af mit wifi?"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "forskel-paa-signal-frekvenser",
                        "name": "Forskellen på 2,4 GHz og 5 GHz"
                    }
                ]}
            />
        </>
    )
}
